import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Guardian } from 'src/app/_models/guardian';
import { Student } from 'src/app/_models/student';
import { GuardianService } from './../../_services/guardian.service';

declare var window: any;
@Component({
  selector: 'app-guardian-home-new',
  templateUrl: './guardian-home-new.component.html',
  styleUrls: ['./guardian-home-new.component.css']
})

export class GuardianHomeNewComponent implements OnInit {
  @Output()  regFinished = new EventEmitter<string>()
  guardian = new Guardian()
  student = new Student()
  studentRegModal:any
  trialModal:any
  invoicing =false
  provisioning=false
  studentDetail:any=undefined
  firstQuizLoading=false

  isEnrolling=false
  constructor(
    private guardianService:GuardianService,
    private route:ActivatedRoute
    ) { }

  ngOnInit(): void {
    this.route.params.subscribe(
      params=>{
        this.guardianService.getByUserId(params['server_user_id']).subscribe(
          x=>{
            this.guardian=x
          }
        )
      }
    )
    this.guardianService.guardianSubject.subscribe(
      x=>{
        this.guardian=x
        if(this.guardian.students.length>0){
          this.studentDetail = this.guardian.students[0]
        }
      }
    )

  }

  addStudentRegistrationPopup(){
    this.studentRegModal = new window.bootstrap.Modal(
      document.getElementById('regStudentModal')
    );
    this.studentRegModal.show()


  }
  addTrialEnrolmentPopup(){
    this.trialModal = new window.bootstrap.Modal(
      document.getElementById('myTrialEnrolmentModal')
    );
    this.trialModal.show()
  }

  trialLoadingPage(value:boolean){
    Promise.resolve(null).then(() => {
      this.isEnrolling=value
    })
  }
  closeModal(closeModalName:string){
    switch(closeModalName){
      case "trialEnrolModal":
         this.trialModal.hide()
      case "regStudentModal":
         this.studentRegModal.hide()

      default:
        ;
    }
  }
  toggleTrialEnrolLoading(value:boolean){
    this.invoicing =value
    this.setFirstQuizStatus()
  }
  alertProvisioning(value:boolean){
    this.provisioning =value
    this.setFirstQuizStatus()
  }
  setFirstQuizStatus(){
    this.firstQuizLoading=(!this.provisioning && this.invoicing) || (this.provisioning && !this.invoicing) || (!this.provisioning && !this.invoicing)
  }

  reloadMainHomePage(closeModalName:string){
    this.regFinished.emit(closeModalName)
    }

}
